import React from 'react';

import { FormattedMessage } from 'react-intl';

import { TrackingStatusLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const ExternalFulfillmentStatus = () => {
  const { statusMessageDescriptor } = useFulfillmentDisplayContext();

  return (
    <ReadonlyField label={TrackingStatusLabel}>
      {statusMessageDescriptor && <FormattedMessage {...statusMessageDescriptor} />}
    </ReadonlyField>
  );
};
